module.exports = __webpack_public_path__ + "img/39.5f4c968c.jpg";